<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">充电桩设备列表</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <div class="page-action-btns flex margin-tb-10">
        <!-- <button class="common-bg-button" @click="getLabels(true)">
          标签管理
        </button>
        <button class="common-bg-button" @click="disDealerDialog('dealerForm')">
          分配运营商
        </button> -->
        <!-- <button class="common-bg-button" @click="editDialog()"></button>
          编辑
        </button> -->
        <button class="common-bg-button" @click="editDialog()">
          查看
        </button>
        <button class="common-bg-button" @click="Unbinding">
          解绑
        </button>
        <!-- <button class="common-bg-button" @click="DealerDialog()">
          操作日志
        </button> -->
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="handleSearch()">
          搜 索
        </button>
        <button class="common-bg-button" @click="() => {
          showMultiQuerys = !showMultiQuerys;
        }">高级筛选</button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">充电桩显示名称</p>
              <el-input v-model="queryInfo.pileName" size="small" clearable placeholder="请输入充电桩显示名称"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">充电桩型号</p>
              <el-input clearable v-model="queryInfo.pileTypeName" size="small" placeholder="请输入充电桩型号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">共享状态</p>
              <el-select class="full-width" size="small" v-model="queryInfo.shareModel" clearable placeholder="请选择共享状态">
                <el-option label="共享" value="SHARE"></el-option>
                <el-option label="自用" value="SELF"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">充电桩状态</p>
              <el-select class="full-width" size="small" v-model="queryInfo.pileStatus" clearable
                placeholder="请选择充电桩状态">
                <el-option label="离线" value="07"></el-option>
                <el-option label="待机" value="04"></el-option>
                <el-option label="充电中" value="01"></el-option>
                <el-option label="故障" value="05"></el-option>
              </el-select>
            </el-col>

            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字</p>
              <el-input v-model="queryInfo.keyWord" size="small" clearable placeholder="请输入充电桩编号/IMEI号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">所属用户</p>
              <el-input v-model="queryInfo.mobile" size="small" clearable placeholder="请输入用户手机号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">是否开通私桩共享</p>
              <el-select class="full-width" size="small" v-model="queryInfo.shareActive" clearable placeholder="请选择">
                <el-option label="开通" value="1"></el-option>
                <el-option label="未开通" value="0"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">绑定渠道</p>
              <el-select class="full-width" size="small" v-model="queryInfo.bindSource" clearable placeholder="请选择绑定渠道">
                <el-option label="挚达APP" value="01"></el-option>
                <el-option label="挚达支付宝小程序" value="02"></el-option>
                <el-option label="桩到家个人站支付宝小程序" value="03"></el-option>
                <el-option label="桩到家个人站微信小程序" value="04"></el-option>
                <el-option label="支付宝车生活" value="05"></el-option>
                <el-option label="支付宝个人站" value="15"></el-option>
                <el-option label="支付宝小程序" value="14"></el-option>
              </el-select>
            </el-col>

            <el-col :span="6">
              <p class="margin-bottom-5 font-14">充电桩类型</p>
              <el-select class="full-width" size="small" v-model="queryInfo.chargingPileType" clearable
                placeholder="请选择">
                <el-option label="壁挂式" value="WALL_MOUNTED"></el-option>
                <el-option label="便携式" value="PORTABLE"></el-option>
                <el-option label="五菱桩" value="WULING"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates='operates' :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "></ZD-table>
      </div>
      <el-dialog title="提示" :visible.sync="centerDialogVisible" width="24%" center>
        <span>是否确认解绑充电桩，点击确认则解绑，点击取消则关闭弹框</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="unBindPile">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      showMultiQuerys: false,//高级筛选
      queryInfo: {}, //标签页 搜索字段
      isFirstLoad: true, // 是否首次加载
      labelVisible: false, //标签管理弹窗
      dealerVisible: false, //分配运营商弹窗
      selectLabelVisible: false, //选择标签弹窗
      labelName: "11", //	未使用
      labelForm: {}, //标签管理内容
      dealerForm: {}, //分配运营商内容
      checkList: [], //选中标签
      labelsArr: [], //客户标签
      selectLabelForm: {}, //所有标签内容
      labelSum: 0, //合计客户数量 默认0
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      },
      centerDialogVisible: false,
      options: [], //未使用
      value: [], //未使用
      dealerList: [], //分配所有运营商弹窗
      loading: false, //未使用
      dealNameArr: [], //未使用
      mobileArr: [], //未使用
      //btnUse: false,
    };
  },
  methods: {
    init() {
      // 首次加载不调用接口
      // this.getListData(this.pagination, true);
    },
    // 检查是否有查询条件
    hasQueryConditions() {
      const { pileName, pileTypeName, shareModel, pileStatus, keyWord, mobile, shareActive, bindSource, chargingPileType } = this.queryInfo;
      return pileName || pileTypeName || shareModel || pileStatus || keyWord || mobile || shareActive || bindSource || chargingPileType;
    },
    // 搜索方法
    handleSearch() {
      if (!this.hasQueryConditions()) {
        this.$U.error('请输入查询条件');
        return;
      }
      this.isFirstLoad = false;
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      // 如果是首次加载且没有查询条件，不调用接口
      if (this.isFirstLoad && !this.hasQueryConditions()) {
        return;
      }

      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.corpNo = "CO1524100773815";
      // _.$H.post(_, _.$A.cust.pagecust, _.queryInfo).then((res) => {
      _.$H.post(_, _.$A.digitization.getPilePage, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 页面编辑方法
    editDialog() {
      if (this.checkSelectOne()) {
        this.$store.commit('setPileObj', this.selections[0]);
        let url = this.$router.resolve({
          name: "pileDetail",
          query: {
            // pileInfo: this.selections[0],
            // 桩号随 URL 传递：详情页优先读取，避免 localStorage 中残留的
            // custObj/pileObj 抢占导致“第二次查看仍显示第一次的桩”
            pileCode: this.selections[0].pileCode,
            parent: 1
          }
        });
        window.open(url.href, "_blank");
      }
    },
    Unbinding() {
      if (this.checkSelectOne()) {
        if (this.selections[0].pileStatusName == '待机') {
          this.centerDialogVisible = true
        } else {
          this.$U.error('充电桩状态非空闲 无法解绑')
        }
      }
    },
    unBindPile() {
      let _ = this;
      let obj = {
        pileCode: _.selections[0].pileCode,
        corpNo: "CO1524100773815",
        userPhone: _.selections[0].userPhone
      }
      _.$H.post(_, _.$A.digitization.unBindPile, obj).then((res) => {
        this.$U.success('解绑成功')
        this.centerDialogVisible = false
      });
    },
    //选择表格
    checkSelectOne() {
      if (this.selections.length < 1) {
        this.$U.error('请选择需要操作的对象')
        return false
      }
      if (this.selections.length > 1) {
        this.$U.error('只能选择一个操作的对象')
        return false
      }
      return true
    },
    //重置
    reset() {
      this.pagination.current = 1;
      this.queryInfo = {}
      this.tableData = []; // 重置时清空表格数据
      this.pagination.total = 0; // 重置总数
      this.isFirstLoad = true; // 重置为首次加载状态
    },
  },
  mounted() {
    this.init();
  },
};
</script>
